//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getLevelRule} from '@/api/vip/index';

export default {
  data() {
    return {
      ruleList:[]
    };
  },
  methods: {
    get_level_rule(){
      getLevelRule().then((res) => {
            this.ruleList = res.data;
      })
    },
  },
  mounted () {
    this.get_level_rule();
  }
};



// WEBPACK FOOTER //
// ./src/pages/vip/rank_recommend.vue